import { Component, OnInit, Input } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';
import { policy } from './privacy.model';
import { PrivacyService } from './privacy.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
params:any
urlExerciseRight:any = {}
policiesGroup:any = []
isShowModal = false;
modalTitle = "";
modalContent = "";
constructor(  
              private privacyService : PrivacyService, 
              public LANG: CommonUtilitiesService,
              private route: ActivatedRoute
            ) { }
  /**
 * Description: Método que llama el servicio web que obtiene las preguntas frecuentes
 * Autor: Steven Sterling
 * @param N/A
 * @return N/A
 */
ngOnInit() {
  this.getAllPolicy()
  this.route.params.subscribe(params => this.params = params.isLogin);
}
    
getAllPolicy(){
  
    this.privacyService.getAllPolicy().subscribe(((dataResponse:any) => {
      if(dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
        
        dataResponse.obj.forEach((element:policy) => {      
          this.policiesGroup.push({
    
              "name_group": element.policyType.replace('_',' '),
              "pdfRoute": element.pdfRoute,
              "link": element.documentLink && element.documentLink.link
            } 
        )});
      }else{
        this.modalTitle = "Error: ";
        this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
        this.isShowModal = true;
      }
    }),
    (err) => {
      this.modalTitle = "Error: " + err.code;
      this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
      this.isShowModal = true;
    });
    this.getExerciseRight()
  }

  getExerciseRight(){
  
    this.privacyService.getExerciseRight().subscribe(((dataResponse:any) => {
      if(dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
        this.urlExerciseRight = dataResponse.obj
      }else{
        this.modalTitle = "Error: ";
        this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
        this.isShowModal = true;
      }
    }),
    (err) => {
      this.modalTitle = "Error: " + err.code;
      this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
      this.isShowModal = true;
    });
  }
  openPdf(file){
    window.open(file);
  }

}

